// extracted by mini-css-extract-plugin
export var arrow = "cCGs";
export var arrowAnimation = "YAdZ";
export var arrowRotated = "SNvm";
export var divider = "lxXW";
export var noListStyle = "hqVR";